import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import ParrotEmpty from "../../../public/icons/parrot-empty.svg";
export var ContentEmpty = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ _jsxs("section", {
        className: classNames("flex flex-col items-center py-2 space-y-3", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(ParrotEmpty, {})
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-secondary",
                children: children
            })
        ]
    });
};
